export function clearFocus() {
  (document.activeElement as HTMLElement | undefined)?.blur();
}
